import Typography from "../../designComponents/Typography";
import {
  ButtonsSection,
  LabelText,
  ValueText,
} from "../Properties/Details/styles";
interface PromoteProperty {
  perDayRate: number;
  weeklyDiscountRate: number;
  monthlyDiscountRate: number;
}

interface PlatformFee {
  percentageFee: number;
  flatFee: number;
  currency: string;
}

export interface PropertyPromotion {
  promoteProperty: PromoteProperty;
  platformFee: PlatformFee;
  _id: string;
}

function ViewPlatformFees({
  globalSettingsData,
}: {
  globalSettingsData?: PropertyPromotion;
  handleDelete?: (id: string) => void;
}) {
  if (!globalSettingsData) {
    return (
      <div>
        <Typography>No Settings Data</Typography>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        width: "100%",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          borderBottomWidth: 1,
          borderBottomStyle: "dashed",
          display: "flex",
          flexDirection: "row",
          width: "100%",
          paddingBottom: 10,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", width: "100%", flexDirection: "column" }}
        >
          <LabelText style={{ marginBottom: 8 }}>Platform Fee</LabelText>
          <ButtonsSection>
            <LabelText>Percentage Fee (%)</LabelText>
            <ValueText>
              {globalSettingsData?.platformFee?.percentageFee}%
            </ValueText>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>Flat Fee</LabelText>
            <ValueText>€{globalSettingsData?.platformFee?.flatFee}</ValueText>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>Currency</LabelText>
            <ValueText>{globalSettingsData?.platformFee?.currency}</ValueText>
          </ButtonsSection>
        </div>
      </div>
    </div>
  );
}

export default ViewPlatformFees;
